// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"229":"999d87e1c78285ae","603":"d9365ded1dae3bcc","888":"35a0b027ddd8a1ff"}[chunkId] + ".css";
};